import { render } from "./AiFavorableComments.vue?vue&type=template&id=17d841eb&scoped=true"
import script from "./AiFavorableComments.vue?vue&type=script&lang=js"
export * from "./AiFavorableComments.vue?vue&type=script&lang=js"

import "./AiFavorableComments.vue?vue&type=style&index=0&id=17d841eb&scoped=true&lang=css"

import exportComponent from "D:\\Program Files\\vueProject\\sys-bg-sjyy\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-17d841eb"]])

export default __exports__